import React, { useState, ChangeEvent, useRef } from "react";
import { Typography } from "@mui/material";
import { Card } from "src/Components/ui/card";
import { Input } from "src/Components/ui/input";
import { Button } from "src/Components/ui/button";
import CircularProgress from "@mui/material/CircularProgress";
import { Toaster } from "src/Components/ui/toaster";
import { Label } from "src/Components/ui/label"
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../Components/ui/select";


const Settings: React.FC = () => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  // UI states
  const [isLoading, setIsLoading] = useState(false);

  /* ---------------- Image Upload (UI only) ---------------- */
  const [ttlValue, setTtlValue] = useState<number | "">("")
  const [unit, setUnit] = useState<"hours" | "days">("hours")

  const handleTTLChange = (value: string) => {
    const num = Number(value)

    if (isNaN(num)) return

    // HARD BLOCK: do not allow 1–11
    if (num < 12) return

    if (unit === "hours" && num > 720) return
    if (unit === "days" && num > 30) return

    setTtlValue(num)
  }


  return (
    <div className="flex h-screen">
      {isLoading && (
        <div className="absolute inset-0 bg-gray-500/50 flex items-center justify-center z-50">
          <CircularProgress />
        </div>
      )}

      <div className="flex-grow p-4 overflow-y-auto">
        <Toaster />

        {/* ---------------- Profile Picture ---------------- */}
        <Card className="mb-8 p-6 max-w-xl text-left">
          <Label className="text-sm font-semibold">
            Time To Live
          </Label>

          <p className="text-sm text-muted-foreground mt-1">
            Campaign expiry time
          </p>

          <div className="flex gap-3 mt-4 items-center">
            <Input
              type="number"
              value={ttlValue}
              placeholder="Min 12"
              className="w-32"
              onChange={(e) => handleTTLChange(e.target.value)}
              onBlur={() => {
                if (ttlValue !== "" && ttlValue < 12) {
                  setTtlValue(12)
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault()
                }
              }}
            />


            {/* 👇 YOUR EXISTING SHADCN DROPDOWN */}
            <Select
              value={unit}
              onValueChange={(val) => {
                setUnit(val as "hours" | "days")
                setTtlValue("")
              }}
            >
              <SelectTrigger className="w-[120px]">
                <SelectValue placeholder="Unit" />
              </SelectTrigger>

              <SelectContent>
                <SelectItem value="hours">Hours</SelectItem>
                <SelectItem value="days">Days</SelectItem>
              </SelectContent>
            </Select>
          </div>


          <p className="text-xs text-muted-foreground mt-2">
            Minimum <b>12 hours</b> · Maximum <b>30 days</b>
          </p>

          <Button className="mt-4 w-[130px]">
            Update TTL
          </Button>
        </Card>


      </div>
    </div>
  );
};

export default Settings;
;
